import React from 'react';
import { getErrorMessage } from '../utils/errorHandler';

/**
 * Safely renders error messages, handling both string and object errors
 */
export default function ErrorDisplay({ error, className = 'text-red-600 font-medium' }) {
  if (!error) return null;
  
  const message = typeof error === 'string' ? error : getErrorMessage(error);
  
  return <p className={className}>{message}</p>;
}
